import React, {useEffect, useState} from 'react';
import { Head, Loading} from "../../components";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { UserAutocomplete} from './../../components'
import CurrencyFormat from "react-currency-format";
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { DatePicker } from "zaman";
import {financePerUser, period} from "../../actions";
import PeriodAutoComplete from "../../components/Period";
import FinanceGroupExcelDownload from "./excelGroup";
import queryString from 'query-string';

const FinancePerUser = ( props ) => {


    const location = useLocation();
    const history = useNavigate();
    const  AppState  = useSelector(state => state);

    const dispatch = useDispatch();

    const [searchTime, setSearchTime] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (AppState.period.ready !== 'success') {
            dispatch(period());
        }
    }, [AppState.period.ready]);

    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {
            _makeQueryStringParams(event.target.name, event.target.value)

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(()=>{

                _makeQueryStringParams(name, word)

            },500);

            setSearchTime(loop);
        }


    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        _makeQueryStringParams(name, value)

    };



    useEffect(() => {
        if (AppState.finance.ready !== 'success') {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [AppState.finance.ready]);




    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        page: query.page && !isNaN( query.page) ? parseInt(query.page) : 1,
        limit: query.limit && !isNaN( query.limit) ? parseInt(query.limit) : 100,
        user_id: query.user_id && !isNaN( query.user_id) ? parseInt(query.user_id) : '',
        sort_field: query.sort_field ? query.sort_field : 'id',
        sort_type: query.sort_type ? query.sort_type : 'desc',
        from_date: query.from_date ? query.from_date : '',
        to_date: query.to_date ? query.to_date : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
        type: query.type ? query.type : '',
        value: query.value ? query.value : '',
    });


    const handleRequest = () => {
        dispatch(financePerUser({
            sort_field: params.sort_field,
            sort_type: params.sort_type,
            page: params.page,
            limit: params.limit,
            from_date: params.from_date,
            to_date: params.to_date,
            user_id: params.user_id,
            name: params.name,
            username: params.username,
            national_code: params.national_code,
            mobile: params.mobile,
            type: params.type,
            value: params.value,
        }));
    }

    useEffect(() => {


        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.sort_field,
        params.sort_type,
        params.page,
        params.limit,
        params.from_date,
        params.to_date,
        params.user_id,
        params.name,
        params.username,
        params.national_code,
        params.mobile,
        params.type,
        params.value,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if ((n_params.page) !== (query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'sort_field':
                    if (n_params.sort_field !== query.sort_field) {
                        n_params.sort_field = query.sort_field;
                        n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                    }
                    break;
                case 'limit':
                    if ((n_params.limit) !== (query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'from_date':
                    if (n_params.from_date !== query.from_date) {
                        n_params.from_date = query.from_date;
                    }
                    break;
                case 'to_date':
                    if (n_params.to_date !== query.to_date) {
                        n_params.to_date = query.to_date;
                    }
                    break;
                case 'user_id':
                    if ((n_params.user_id) !== (query.user_id)) {
                        n_params.user_id = parseInt(query.user_id);
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                case 'value':
                    if (n_params.value !== query.value) {
                        n_params.value = query.value;
                    }
                    break;
                case 'type':
                    if (n_params.type !== query.type) {
                        n_params.type = query.type;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.sort_field,
        query.sort_type,
        query.page,
        query.limit,
        query.from_date,
        query.to_date,
        query.user_id,
        query.name,
        query.username,
        query.national_code,
        query.mobile,
        query.value,
        query.type,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = parseInt(value);
                break;
            case 'sort_field':
                n_params.sort_field = value;
                n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                break;
            case 'limit':
                n_params.limit = parseInt(value);
                break;
            case 'from_date':
                n_params.from_date = value;
                break;
            case 'to_date':
                n_params.to_date = value;
                break;
            case 'user_id':
                n_params.user_id = parseInt(value);
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;
            case 'type':
                n_params.type = value;
                break;
            case 'value':
                n_params.value = value;
                break;

        }

        let url = '?';
        url += `page=${n_params.page}`;
        url += `&sort_field=${n_params.sort_field}`;
        url += `&sort_type=${n_params.sort_type}`;
        url += `&limit=${n_params.limit}`;
        url += `&from_date=${n_params.from_date}`;
        url += `&to_date=${n_params.to_date}`;
        url += `&user_id=${n_params.user_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&mobile=${n_params.mobile}`;
        url += `&type=${n_params.type}`;
        url += `&value=${n_params.value}`;

        history(`/finance/group/${url}`);

    };

    const pageCount = Math.ceil(parseInt(AppState?.finance?.entities?.total) / parseInt(AppState?.finance?.entities?.per_page));

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'مدیریت کیف پول ها', 'description': 'مدیریت مالی کیف پول ها' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <PeriodAutoComplete list={AppState.period.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                            <Grid item xs={12} sm={4} md={3} >
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('user_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="ایمیل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='email'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="نوع"
                                    value={params.type}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='type'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={""}>انتخاب</MenuItem>
                                    {AppState.finance.type && Object.keys(AppState.finance.type).map((item) => {
                                        return(<MenuItem value={item}>{AppState.finance.type[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت بدهکار و بستانکار"
                                    value={params.value}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='value'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={""}>انتخاب</MenuItem>
                                    {AppState.finance.value && Object.keys(AppState.finance.value).map((item) => {
                                        return(<MenuItem value={item}>{AppState.finance.value[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={9}></Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='datepicker-input-container'>
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('from_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='datepicker-input-container'>
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('to_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                            <MenuItem  value="500">500</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <FinanceGroupExcelDownload object={params} />
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>شناسه کاربر</th>
                        <th>کاربر</th>
                        <th>بدهکار</th>
                        <th>بستانکار</th>
                        <th>مبلغ کل</th>
                    </tr>
                    </thead>
                    <tbody>
                    {AppState.finance.entities.data && AppState.finance.entities.data.map((entity, index) => {
                        return(
                            <tr key={index}>
                                <td>{entity.user.id}</td>
                                <td><Link to={'/marketer/' + entity.user_id}>{entity.user && (entity.user.name && entity.user.name + ' ' + entity.user.family)}<br/>{entity.user && entity.user.mobile}</Link></td>
                                <td><CurrencyFormat value={entity.debtor}  displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={entity.creditor}  displayType={'text'} thousandSeparator={true}  /></td>
                                <td><CurrencyFormat value={entity.total}  displayType={'text'} thousandSeparator={true}  /></td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
        </div>

    );
}


export default FinancePerUser;
